export default "__VITE_ASSET__C5dZB4H3__"